export const getProductStatus = (product: any) => {
    if ((product.stock || 0) < product.minimumStock) {
        return 'danger'
    }
    if ((product.stock || 0) === product.minimumStock) {
        return 'warning'
    }
    return 'success'
}
